export default __webpack_public_path__ + "static/media/pp-business-loan.d31630ac.svg";